import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class VehicleNeedsClusterRemovedDetailsDto {
  vin?: string = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  importerStockNumber?: string = undefined
}

export const vehicleNeedsClusterRemovedDetailsValidationSchema = yup.object({
  vin: yup.string().required('VIN is required.'),
  exporterCompany: yup.object().required('Exporter Company is required.'),
  buyerCompany: yup.object().required('Buyer Company is required.'),
  year: yup.number().required('Year is required.'),
  make: yup.string().required('Make is required.'),
  model: yup.string().required('Model is required.'),
  importerStockNumber: yup.string().required('Importer Stock Number is required.')
})
